import {
  SET_MANDAYS_DATA,
  MANDAYS_FETCHING_INIT,
  MANDAYS_FETCHING_COMPLETED,
} from "./types";
const initialState = {
  _mandays: [],
  _fetching: false,
  _refetch: false,
  _incentive: "",
  _days: "",
  _mandayDetails: {},
  _disableBtn: false,
  _popUpEdit: false,
  _eaflag: "",
  _plansize: "",
  _endrange: "",
  _startrange: "",
  isitadd: false,
  deleteid: null,
  confirmdisable: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_MANDAYS_DATA:
      return { ...state, ...action.payload };
    case MANDAYS_FETCHING_INIT: {
      return { ...state, _fetching: true, _refetch: false };
    }
    case MANDAYS_FETCHING_COMPLETED: {
      return { ...state, _fetching: false, ...action.payload };
    }
    default:
      return state;
  }
};
